// 레이어·상세가 열린 동안 뒤 페이지 스크롤을 막는다.
// body를 고정하는 방식이라 iOS 사파리에서도 동작하고, 풀면 원래 스크롤 위치로 돌아간다.

let lockCount = 0;
let savedScrollY = 0;

export function lockPageScroll() {
  lockCount += 1;
  if (lockCount > 1) return;
  savedScrollY = window.pageYOffset || 0;
  // 잠그면 PC 스크롤 막대가 사라지면서 화면이 그만큼 옆으로 밀린다(열 때 깜빡이는 느낌).
  // 막대 너비만큼 자리를 남겨 화면이 움직이지 않게 한다.
  const barWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
  document.documentElement.style.setProperty("--scroll-lock-pad", `${barWidth}px`);
  const s = document.body.style;
  s.position = "fixed";
  s.top = `-${savedScrollY}px`;
  s.left = "0";
  s.right = "0";
  s.width = "100%";
  s.overflow = "hidden";
  if (barWidth > 0) s.paddingRight = `${barWidth}px`;
}

export function unlockPageScroll() {
  if (lockCount === 0) return;
  lockCount -= 1;
  if (lockCount > 0) return;
  const s = document.body.style;
  s.position = "";
  s.top = "";
  s.left = "";
  s.right = "";
  s.width = "";
  s.overflow = "";
  s.paddingRight = "";
  document.documentElement.style.removeProperty("--scroll-lock-pad");
  window.scrollTo(0, savedScrollY);
}
